import React, { useState, useEffect } from "react";
import {
  IconButton,
  FormControl,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function Search() {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleSearch = () => {
    const trimmedValue = searchValue.trim();
    if (trimmedValue === "") {
      return;
    }
    navigate(`/stores?search=${encodeURIComponent(trimmedValue)}`);
    setSearchValue(trimmedValue);
  };

  const handleClear = () => {
    setSearchValue("");
  };

  useEffect(() => {
    if (location.pathname !== "/stores") {
      setSearchValue("");
    }
  }, [location.pathname]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div dir="rtl" style={{ width: "74%" }}>
      <FormControl fullWidth sx={{ marginBottom: 0 }}>
        <OutlinedInput
          placeholder="ابحث في كوبون أول طلب"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={{
            color: "#5b5b5c",
            backgroundColor: "#fff",
            borderRadius: "5px",
            "& input": { color: "#303031" },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f1f3f5",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#f1f3f5",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#D3D3D3",
            },
          }}
          endAdornment={
            <InputAdornment position="end">
              {searchValue && (
                <IconButton onClick={handleClear}>
                  <ClearIcon />
                </IconButton>
              )}
              <IconButton onClick={handleSearch}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </div>
  );
}

export default Search;
